<template>
  <v-menu left
          nudge-left="52">
    <template v-slot:activator="{ on, value }">
      <v-btn color="accent"
             text
             v-bind:disabled="disabled || value"
             v-on="on">
        {{ $t('clear') }}
      </v-btn>
    </template>
    <v-card flat>
      <v-btn block
             color="deep-orange"
             dark
             depressed
             tile
             v-on:click="$emit('clear')">
        {{ $t('confirmClear') }}
      </v-btn>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    name: 'ClearListButton',
    props: {
      disabled: Boolean
    }
  }
</script>

<i18n>
  {
    "de": {
      "clear": "Leeren",
      "confirmClear": "Liste leeren"
    },
    "en": {
      "clear": "Clear",
      "confirmClear": "Really clear?"
    }
  }
</i18n>
